var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var mediaReducer = function (items, action) {
    switch (action.type) {
        case "INIT": {
            return __assign(__assign({}, items), action.item);
        }
        case "MEDIA_CHANGE": {
            return __assign(__assign({}, items), action.item);
        }
        default: {
            var exhaustiveCheck = action;
            throw Error("MediaReducer: Unhandled action ".concat(String(exhaustiveCheck)));
        }
    }
};
export default mediaReducer;
